<template>
  <div
    class="loading-indicator"
  >
    <div class="loading-indicator__image">
      <!-- eslint-disable-next-line -->
      <svg class="throbber" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><g class="throbber__arrows"><path fill="#00aad5" d="M34.8 40l3 5.6L46 23.8 23.1 18l3 5.7C14 31.6 6.5 44.4 5 58.1L23.3 60c.9-7.8 4.9-15.1 11.5-20"/><path fill="#00aad5" d="M108.6 51.7c-1.5-14.1-9.4-26.3-20.7-33.7L78 33.1c6.5 4.2 11.1 11 12.4 18.9l-6.2.1L99.7 69 115 51.6l-6.4.1z"/><path fill="#00aad5" d="M50.4 80.5l3.1-5.5L31 79.7l7.2 22.3 3.2-5.6c13 6 27.5 5.4 39.6-.6l-8-16.4c-6.9 3.5-15.1 4-22.6 1.1"/></g><path class="throbber__crane" fill="#1c1c1c" d="M43.1 57.8c.2.3 3.5 6.5 10 9.5l6.3-12.9 7.4 13.1c6.7-2.8 9.9-9.1 10.1-9.4l.6-1.2-15.3-18.4v-44h-4.1v44l-15.6 18 .6 1.3zm17.1-15.4l6.7 8.1H53.2l7-8.1z"/></svg>
    </div>
    <div
      v-if="showText"
      class="loading-indicator__text"
      role="status"
    >
      {{ showText }}...
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadingIndicator',
  props: {
    showText: {
      type: String,
      default: 'Loading',
    },
    wide: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style scoped lang="scss">
.loading-indicator{
  @keyframes upDown {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(-2.5rem);
    }
  }
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 5rem;
  &__image {
    height: 10rem;
    width: 10rem;
  }
  .throbber {
    &__crane {
      animation: 1.5s upDown alternate infinite;
    }
    &__arrows {
      animation: 2s rotate360 linear infinite;
      transform-origin: center 6rem;
    }
  }
}
</style>
